import { createInstance, i18n, Resource } from 'i18next';
import { initReactI18next } from 'react-i18next/initReactI18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import i18nConfig from '@i18nConfig';
import { Locales, NameSpace } from '@/types/i18n';

export default async function initTranslations( locale: Locales,
  namespaces: string[],
  i18nInstance: i18n | null = null,
  resources: Resource | undefined = undefined ) {
  i18nInstance = i18nInstance || createInstance();

  i18nInstance.use(initReactI18next);

  if (!resources) {
    i18nInstance.use(
      resourcesToBackend(
        ((language: Locales, namespace: NameSpace) =>
          import(`@/locales/${language.replace('-', '_')}/${namespace}.json`)
        ) as unknown as typeof resourcesToBackend
      )
    );
  }

  await i18nInstance.init({
    lng: locale,
    resources,
    fallbackLng: i18nConfig.defaultLocale,
    supportedLngs: i18nConfig.locales,
    defaultNS: namespaces[0],
    fallbackNS: namespaces[0],
    ns: namespaces,
    preload: resources ? [] : i18nConfig.locales,
    debug: false,
  });

  return {
    i18n: i18nInstance,
    resources: i18nInstance.services.resourceStore.data,
    t: i18nInstance.t,
  };
}
